module.exports = __webpack_public_path__ + "static/media/canimolt_BannersCenso_WEBDIRECTA.d8326580.jpg";